import { CSSProperties, ReactNode } from "react";
import { IPOAccount } from "../index";

export enum FlexEnum {
	TOP = 'TOP',
	BOTTOM = 'BOTTOM',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
}

export enum ModeEnum {
	SIMPLE = 'SIMPLE',
	CUSTOM = 'CUSTOM',
}

export enum MsgEnum {
  SMS = 'SMS',
  WX = 'WX',
  WHATSAPP = 'WHATSAPP',
  LINE = 'LINE',
}
export interface IUserMenuProps {
  handleExit: () => void;
  handleEnterAccount: () => void;
  handleEnterHelp: () => void;
  handleChangeMsgType: (msgType: MsgEnum) => void;
  handleEnterProfile: () => void;
}

export interface IUserOpesProps {
  user: IPOAccount.IAccount;
  baseUrl?: string;
  style?: CSSProperties;
}

export type TUserOpes = IUserOpesProps & IUserMenuProps;

export interface IUnread {
  groupId: string;
  projectId: string;
  avatar: ReactNode;
  groupName: string;
  groupWork?: string;
  unreadCount: number;

  lastId: string;
  lastTime?: string;
  lastUser?: ReactNode;
  lastMsg?: string;
}
export interface IChats {
  handleGoProject: (id: string) => void; // 点击进入项目
  unreadNum: number;
  unreadMsgs: IUnread[]
} 

export type IUserHeaderProps = TUserOpes & IChats